import * as WebSocket from 'isomorphic-ws';
import { Operation as LoggingOperation, Log, LogCategory } from '@augloop/logging';
import { LogCountLimiter } from '../utils';
var WebSocketWorker = /** @class */ (function () {
    function WebSocketWorker() {
        this.hasBeenOpened = false;
        this.hadEgressError = false;
        this.lastEgressTime = 0;
        this.lastPongTime = 0;
        this.remainingPingFailures = 3;
        // All request messages will be put into this array before the WebSocket becomes open.
        this.pendingEgress = [];
    }
    WebSocketWorker.prototype.init = function (url, ingress, onOpen, onClose) {
        var _this = this;
        this.ws = new WebSocket(url);
        this.logOp = new LoggingOperation({ operationName: WebSocketWorker.className, success: true }).start();
        var logPingLatency = function (success) {
            if (!_this.logPingLatencyOp) {
                return;
            }
            _this.logPingLatencyOp.success = success;
            Log.info(0x2224d0cb /* tag_8jndl */, LogCategory.CoreDefault, _this.logPingLatencyOp.stop());
            _this.logPingLatencyOp = undefined;
        };
        this.ws.addEventListener('open', function (_event) {
            onOpen();
            WebSocketWorker.logCountLimiter.log(function () {
                _this.logOp.resourceId = 'OnOpen';
                _this.logOp.resultDescription = '';
                _this.logOp.success = true;
                Log.info(0x2224d0cc /* tag_8jndm */, LogCategory.CoreDefault, _this.logOp.stop());
            });
            _this.hasBeenOpened = true;
            _this.pendingEgress.forEach(function (message) {
                _this.egress(message);
            });
            _this.pendingEgress = [];
            _this.pingInterval = setInterval(function () {
                if (_this.logPingLatencyOp) {
                    --_this.remainingPingFailures;
                    logPingLatency(false);
                }
                if (_this.remainingPingFailures > 0 && _this.hasBeenOpened && _this.lastPongTime < _this.lastEgressTime) {
                    _this.logPingLatencyOp = new LoggingOperation({
                        operationName: 'Ping',
                        success: true,
                        dimension0: _this.ws.bufferedAmount >= 0 ? _this.ws.bufferedAmount.toString().length.toString() : undefined
                    }).start();
                    _this.ws.send(WebSocketWorker.pingPongMessage, function (err) {
                        if (err) {
                            --_this.remainingPingFailures;
                            logPingLatency(false);
                        }
                    });
                }
            }, 30000);
        });
        this.ws.addEventListener('message', function (event) {
            if (_this.logPingLatencyOp
                && typeof event.data === 'string'
                && event.data.length === 1
                && event.data[0] === WebSocketWorker.pingPongMessage) {
                logPingLatency(true);
                _this.lastPongTime = Date.now();
            }
            else {
                ingress(event.data);
            }
        });
        this.ws.addEventListener('error', function (event) {
            _this.errorMessage = event.message;
            WebSocketWorker.logCountLimiter.log(function () {
                _this.logOp.resourceId = 'OnError';
                _this.logOp.resultDescription = _this.errorMessage;
                _this.logOp.success = false;
                Log.info(0x2224d0cd /* tag_8jndn */, LogCategory.CoreDefault, _this.logOp.stop());
            });
            _this.ws.close();
        });
        this.ws.addEventListener('close', function (event) {
            WebSocketWorker.logCountLimiter.log(function () {
                _this.logOp.resourceId = 'OnClose';
                _this.logOp.resultDescription = event ? "code: ".concat(event.code, ". reason: ").concat(event.reason) : '';
                _this.logOp.success = true;
                Log.info(0x2224d0ce /* tag_8jndo */, LogCategory.CoreDefault, _this.logOp.stop());
            });
            if (_this.pingInterval) {
                clearInterval(_this.pingInterval);
                _this.pingInterval = undefined;
            }
            onClose(_this.errorMessage);
        });
    };
    WebSocketWorker.prototype.egress = function (obj) {
        var _this = this;
        this.lastEgressTime = Date.now();
        // Send the message directly when the WebSocket if it has been opened at some point,
        // otherwise, put the message into the pending queue.
        if (this.hasBeenOpened) {
            this.ws.send(obj, function (err) {
                if (err && !_this.hadEgressError) {
                    _this.hadEgressError = true;
                    WebSocketWorker.logCountLimiter.log(function () {
                        _this.logOp.resourceId = 'OnFirstEgressError';
                        _this.logOp.resultDescription = err.message;
                        _this.logOp.success = false;
                        Log.info(0x2224d0cf /* tag_8jndp */, LogCategory.CoreDefault, _this.logOp.stop());
                    });
                }
            });
        }
        else {
            this.pendingEgress.push(obj);
        }
    };
    WebSocketWorker.prototype.close = function () {
        if (this.pingInterval) {
            clearInterval(this.pingInterval);
            this.pingInterval = undefined;
        }
        this.ws.close();
    };
    WebSocketWorker.className = 'WebSocketWorker';
    WebSocketWorker.logCountLimiter = new LogCountLimiter(WebSocketWorker.className);
    WebSocketWorker.pingPongMessage = '~';
    return WebSocketWorker;
}());
export { WebSocketWorker };
//# sourceMappingURL=websocket-worker.js.map